<div
  class="card-body contacts_body p-0 dz-scroll"
  id="DZ_W_Contacts_Body1"
>
  <div>
    <div class="search-container">
      <input
        type="search"
        class="form-control border-0 p-3 pt-3 pe-5 pb-2 mb-1"
        [placeholder]="'common.search' | translate"
        [(ngModel)]="searchTerm">
      <i class="fa fa-search search-icon pt-2"></i>
    </div>
  </div>

  <ul class="contacts">
    <li class="name-first-letter unread-section">
      {{ "user-announcement.unread-announcements" | translate }}
    </li>
    <li
      *ngFor="let item of unreadAnnouncements; let i = index"
      class="announcement-item"
    >
      <div (click)="openAnnouncement(item)" role="button" tabindex="-1">
        <span class="announcement-title">{{ item?.topic }}</span>
        <p class="announcement-time text-primary">
          {{ item?.startDate | dateFormat }} -
          {{ item?.endDate | dateFormat }}
        </p>
      </div>
    </li>

    <div
      *ngIf="this.unreadAnnouncements.length === 0"
      style="justify-content: center; align-items: center"
    >
      <app-empty-data
        [title]="
                    'user-announcement.no-exist-unread-announcement' | translate
                  "
        icon="mdi mdi-information-outline"
        containerClass="opacity-50"
        iconSize="40px"
        iconColor="gray"
        titleSize="10px"
        titleColor="gray"
        messageSize="14px"
        messageColor="gray"
      >
      </app-empty-data>
    </div>

    <li class="name-first-letter read-section">
      {{ "user-announcement.read-announcements" | translate }}
    </li>
    <li
      *ngFor="let item of readAnnouncements"
      class="announcement-item"
    >
      <div
        class="d-flex bd-highlight"
        (click)="openAnnouncement(item)"
        role="button"
        tabindex="-1"
      >
        <div class="user_info">
          <span class="announcement-title">{{ item?.topic }}</span>
          <p class="announcement-time text-dark">
            {{ item?.startDate | dateFormat }} -
            {{ item?.endDate | dateFormat }}
          </p>
        </div>
      </div>
    </li>
    <div
      *ngIf="this.readAnnouncements.length === 0"
      style="justify-content: center; align-items: center"
    >
      <app-empty-data
        [title]="
                    'user-announcement.no-exist-read-announcement' | translate
                  "
        icon="mdi mdi-information-outline"
        containerClass="opacity-50"
        iconSize="40px"
        iconColor="gray"
        titleSize="10px"
        titleColor="gray"
        messageSize="14px"
        messageColor="gray"
      >
      </app-empty-data>
    </div>
  </ul>
</div>
